import { styled } from 'baseui'
import { lightTheme } from '@/customTheme'

export const SkeletonItem = styled('div', () => ({
  borderRadius: '8px',
  background: lightTheme.colors.grayScale50,
}))
